import React, { useContext, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

import {
  COLUMN_NAMES as INQUIRY_COLUMN_NAMES,
  Inquiry,
  InquiryFetchArgs,
  getInquiryViews,
} from '../../assets/ts/data/inquiry/inquiry'
import { scrollToTop } from '../../assets/ts/general/general'
import ExportToCSVButton from '../../components/buttons/export-to-csv-btn'
import Filters from '../../components/filters/filters'
import KPIs from '../../components/kpi/kpis'
import PageOverlayBusy from '../../components/page-overlay/page-overlay-busy'
import AllInquiriesTable from '../../components/table/all-inqiries-table'
import Tabs from '../../components/tabs/tabs'
import useInquiryCount from '../../hooks/inquiry/use-inquiry-count'
import useInquiryDistinctValues from '../../hooks/inquiry/use-inquiry-distinct-values'
import useInquiryViews from '../../hooks/inquiry/use-inquiry-views'
import usePageAccumulator from '../../hooks/usePageAccumulator'
import PageHeader from '../../layouts/header/page-header'
import { PreviousPageContext } from '../../store/previous-page-provider'
import { RoleContext } from '../../store/role-context-provider'
import { SelectionContext } from '../../store/selection-context-provider'
import { UserContext } from '../../store/user-context-provider'
import {
  ALL_SELECT_VALUE,
  ALL_SELECT_VALUE_STRING,
  INQUIRY_INITIAL_FILTER,
} from '../../utils/constants/global-constants'
import ActionButtonsContainer from '../detail-view/action-buttons-container/action-buttons-container'
import './inquiries.css'

const InquiriesList = (props: any) => {
  const location = useLocation()

  const inqFilter = location.state

  const { me } = useContext(UserContext)
  const selection = useContext(SelectionContext)
  const { initialInquiryAndDueoutFilter, isLeadership } = useContext(RoleContext)
  const { currentPage, setCurrentPage, setPreviousPage } = useContext(PreviousPageContext)

  const [kpiName, setKpiName] = useState('ALL INQUIRIES')
  const [currentUserRole, setCurrentUserRole] = useState<string>('')
  const [pageNum, setPageNum] = useState(0)
  const [disableCheckBox, setDisableCheckBox] = useState<boolean>(false)

  const [exportFetchIsBusy, setExportFetchIsBusy] = useState(false)
  const UserRoleCodes: Partial<InquiryFetchArgs> = {
    userLoginRole: {
      CSSPASCODEFilter: initialInquiryAndDueoutFilter?.cssPASCODES,
      usersAssignedComponentCode: initialInquiryAndDueoutFilter?.assignedComponentCodeFilter,
      usersMajcomCodeFilter: initialInquiryAndDueoutFilter?.majcomCodeFilter,
      usersSectionCodeFilter: initialInquiryAndDueoutFilter?.sectionCodeFilter,
      usersServicingOrganizationFilter: initialInquiryAndDueoutFilter?.servicingOrganizationFilter,
      usersServicingOrganizationWithoutSectionFilter:
        initialInquiryAndDueoutFilter?.servicingOrganizationWithoutSectionFilter,
    },
  }
  const initialInquiriesFilter = {
    ...INQUIRY_INITIAL_FILTER,
    isViewApplied: true,
    notSelfFilter: me.userId,
  }
  const [inquiryFilter, setInquiryFilter] = useState<InquiryFetchArgs>({
    ...initialInquiriesFilter,
    ...UserRoleCodes,
    hasCanceledClosedAndResolved: false,
  })

  const inquiryPaging: InquiryFetchArgs = {
    pageNumber: pageNum,
  }
  const { inquiries, inquiriesAreLoading } = useInquiryViews({
    ...inquiryFilter,
    ...inquiryPaging,
  })
  const { inquiryCount, inquiryCountIsLoading, inquiryCountValue } = useInquiryCount({
    ...inquiryFilter,
  })
  const inquiryCountString =
    inquiryCount.length === 1 ? inquiryCount[0].InquiryGUID_count.toLocaleString() : '--'

  const getSearch = (event: { target: { value: string } }): void => {
    const searchWord: string = event.target.value.toLocaleLowerCase()
    if (searchWord !== '') {
      setInquiryFilter({ ...inquiryFilter, searchFilter: searchWord })
    } else {
      setInquiryFilter({ ...inquiryFilter, searchFilter: searchWord })
    }
  } //we might consider de-bouncing the search in the future to avoid re-rendering on every keystroke
  const resetFilterOptions = (priorArgs, order, updatedArgs) => ({
    ...priorArgs,
    assignedComponentCodeFilter:
      order && order >= 2 ? priorArgs.assignedComponentCodeFilter : ALL_SELECT_VALUE,
    assignedToLocationFilter:
      order && order >= 6 ? priorArgs.assignedToLocationFilter : ALL_SELECT_VALUE_STRING,
    categoryCodeFilter: order && order >= 9 ? priorArgs.categoryCodeFilter : ALL_SELECT_VALUE,
    currentlyServicingByFilter:
      order && order >= 4 ? priorArgs.currentlyServicingByFilter : ALL_SELECT_VALUE_STRING,
    organizationFilter:
      order && order >= 7 ? priorArgs.organizationFilter : ALL_SELECT_VALUE_STRING,
    searchFilter: '',
    sectionCodeFilter: order && order >= 8 ? priorArgs.sectionCodeFilter : ALL_SELECT_VALUE,
    servicingMAJCOMCodeFilter:
      order && order >= 3 ? priorArgs.servicingMAJCOMCodeFilter : ALL_SELECT_VALUE,
    servicingOrganizationFilter:
      order && order >= 5 ? priorArgs.servicingOrganizationFilter : ALL_SELECT_VALUE_STRING,
    subCategoryCodeFilter:
      order && order >= 10 ? priorArgs.subCategoryCodeFilter : ALL_SELECT_VALUE,
    yearFilter: order && order >= 1 ? priorArgs.yearFilter : ALL_SELECT_VALUE,
    ...updatedArgs,
  })
  const updateInquiryFilter = (updatedArgs, order) => {
    selection.reset()
    setPageNum(0)
    setInquiryFilter((priorArgs) => resetFilterOptions(priorArgs, order, updatedArgs))
  }
  const updateKpiFilter = (updatedArgs): void => {
    selection.reset()
    scrollToTop()
    setPageNum(0)
    setInquiryFilter((priorArgs) => ({
      ...priorArgs,
      ...updatedArgs,
    }))
  }

  const accumulatedInquiries = usePageAccumulator(pageNum, inquiries)

  const handleBottomScrollReached = () => {
    if (inquiryCountValue > accumulatedInquiries.length) {
      setPageNum((num) => num + 1)
    }
  }

  const handleClearAll = () => {
    setKpiName('ALL INQUIRIES')
    if (inqFilter?.inqFilter) {
      inqFilter.inqFilter.tabTable = ''
    }
    setInquiryFilter({
      ...initialInquiriesFilter,
      ...UserRoleCodes,
      customerActionRequiredFilter: false,
      hasCanceledClosedAndResolved: false,
    })
    setPageNum(0)
    selection.reset()
  }
  const removeAddedKPIFilters = (filters) => {
    const result = { ...filters }
    const kpis = [
      'activeFilter',
      'assignedToMe',
      'assignedToOther',
      'currentSection',
      'elevatedToMPF',
      'isCPOwnerOrLeadership',
      'isResponsePending',
      'isResponseRequired',
      'needToWorkFilter',
      'pendingActionOutsideFilter',
      'returnedFromMPF',
      'sectionCodeKPIFilter',
      'statusCodeFilter',
      'unassignedFilter',
    ]

    kpis.forEach((kpi) => delete result[kpi])

    return result
  }
  const handleClearAllKPIs = () => {
    setKpiName('ALL INQUIRIES')
    if (inqFilter?.inqFilter) {
      inqFilter.inqFilter.tabTable = ''
    }
    setInquiryFilter(removeAddedKPIFilters(inquiryFilter))
    setPageNum(0)
    selection.reset()
  }

  async function getAllSelectedRecords(): Promise<Inquiry[]> {
    const visibleSelectedRecords = accumulatedInquiries.filter((d) =>
      selection.keyIsSelected(d.InquiryGUID ?? '')
    )
    const unloadedSelectedRecords = await getAllUnloadedSelectedRecords()

    const allSelectedRecords = [...visibleSelectedRecords, ...unloadedSelectedRecords]
    return allSelectedRecords
  }

  async function getAllUnloadedSelectedRecords(): Promise<Inquiry[]> {
    if (selection.unloadedRecordsAreSelected) {
      setExportFetchIsBusy(true)
      // Because the user clicked the Select All in the past, all records
      // matching the current dashboard and KPI filters that are in pages
      // past the currently loaded/visible ones need to be fetched
      const items = await getInquiryViews({
        ...inquiryFilter,
        onePageOnly: false,
        pageNumber: (inquiryPaging.pageNumber ?? 0) + 1,
      })
      setExportFetchIsBusy(false)
      return items
    } else {
      return []
    }
  }
  // When determining the allowed values for the dashboard filters,
  // consider only entries for the current user.  Also use the same value
  // of "isArchived" from the overall list filter
  const { inquiryDistinctValues, inquiryDistinctValuesAreLoading } = useInquiryDistinctValues({
    ...UserRoleCodes,
    assignedComponentCodeFilter: inquiryFilter.assignedComponentCodeFilter,
    assignedToLocationFilter: inquiryFilter.assignedToLocationFilter,
    categoryCodeFilter: inquiryFilter.categoryCodeFilter as number,
    currentlyServicingByFilter: inquiryFilter.currentlyServicingByFilter,
    distinctFiltersToQuery: [
      INQUIRY_COLUMN_NAMES.FY,
      INQUIRY_COLUMN_NAMES.AssignedComponentCode,
      INQUIRY_COLUMN_NAMES.ServicingMAJCOMCode,
      INQUIRY_COLUMN_NAMES.ServicingOrganization,
      INQUIRY_COLUMN_NAMES.Installation,
      INQUIRY_COLUMN_NAMES.Organization,
      INQUIRY_COLUMN_NAMES.CurrentlyServicingBy,
      INQUIRY_COLUMN_NAMES.SectionCode,
      INQUIRY_COLUMN_NAMES.CategoryCode,
      INQUIRY_COLUMN_NAMES.SubCategoryCode,
      INQUIRY_COLUMN_NAMES.AssignedTo,
    ],
    hasCanceledClosedAndResolved: false,
    isArchivedFilter: false,
    notSelfFilter: me.userId,
    organizationFilter: inquiryFilter.organizationFilter,
    relatedUserFilter: inquiryFilter.relatedUserFilter,
    savedFilter: false,
    sectionCodeFilter: inquiryFilter.sectionCodeFilter,
    servicingMAJCOMCodeFilter: inquiryFilter.servicingMAJCOMCodeFilter,
    servicingOrganizationFilter: inquiryFilter.servicingOrganizationFilter,
    subCategoryCodeFilter: inquiryFilter.subCategoryCodeFilter as number,
    yearFilter: inquiryFilter.yearFilter,
  })
  const tableItems = [
    {
      content: (
        <AllInquiriesTable
          csvTitle='ALL INQUIRIES'
          disableCheckBox={disableCheckBox}
          inquiries={accumulatedInquiries}
          onBottomScrollReached={handleBottomScrollReached}
        />
      ),
      count: inquiryCountString,
      isActive: true,
      tabTitle: inqFilter?.inqFilter?.tabTable || `${kpiName.toUpperCase()}`,
    },
  ]
  const busy =
    inquiriesAreLoading ||
    inquiryCountIsLoading ||
    exportFetchIsBusy ||
    inquiryDistinctValuesAreLoading

  useEffect(() => {
    if (inqFilter?.inqFilter) {
      setInquiryFilter((prevFilter) => ({
        ...prevFilter,
        ...inqFilter.inqFilter,
      }))
    }
  }, [inqFilter])

  useEffect(() => {
    selection.mergeWithAllLoadedRecordKeys(inquiries.map((i) => i.InquiryGUID ?? ''))
  }, [inquiries])

  useEffect(() => {
    scrollToTop()
  }, [])

  useEffect(() => {
    // This effect runs whenever the location changes (when the user navigates to a different route)
    if (currentPage !== location.pathname) {
      // User has navigated to a new page, so update the previous page
      setPreviousPage(currentPage) // Previous page
      setCurrentPage(location.pathname) // Update the current page
    }
  }, [location, currentPage]) // Runs whenever location or currentPage changes

  useEffect(() => {
    setInquiryFilter((prevFilter) => ({
      ...prevFilter,
      ...UserRoleCodes,
    }))
  }, [initialInquiryAndDueoutFilter])

  return (
    <>
      <div id='scroll'></div>
      {inquiryFilter.searchFilter === '' && busy && <PageOverlayBusy />}
      <PageHeader
        extras={<div></div>}
        icon='icon-requirements font-14 me-1 color-primary'
        name='Inquiries '
      />
      <div className='container'>
        <div className='row'>
          <div className='col-sm-12 col-lg listview-table'>
            <div className='shadow card w-100 h-100'>
              <div className='card-body'>
                <Tabs
                  anchorclass='title-color2 font-12 poppins-semibold'
                  badge='badge bgcolor-primary font-12 border-radius3 px-2 py-1 whitetext'
                  className='title-color2 lg'
                  isButtons={
                    <div style={{ display: 'flex' }}>
                      <ActionButtonsContainer
                        actionType='Inquiry'
                        currentUserRoleProps={{ currentUserRole, setCurrentUserRole }}
                        fetchSelectedItems={getAllSelectedRecords}
                        isMenusExpanded={props?.isMenusExpanded}
                        pageType='inquiries'
                        setDisableCheckBox={setDisableCheckBox}
                        showAssignTo={
                          inquiryCountValue > 0 &&
                          (inquiryFilter.unassignedFilter === true ||
                            inquiryFilter.statusCodeFilter?.toUpperCase() === 'SUBMITTED' ||
                            inquiryFilter.statusCodeFilter?.toUpperCase() === 'REOPENED')
                        }
                        showElevate={
                          inquiryCountValue > 0 &&
                          (inquiryFilter.unassignedFilter === true ||
                            inquiryFilter.statusCodeFilter?.toUpperCase() === 'SUBMITTED' ||
                            inquiryFilter.statusCodeFilter?.toUpperCase() === 'REOPENED') &&
                          !isLeadership
                        }
                      />
                      {inquiryCount[0]?.InquiryGUID_count !== 0 && (
                        <ExportToCSVButton
                          fetchDataFunc={getAllSelectedRecords}
                          pageType='Inquiries'
                        />
                      )}
                    </div>
                  }
                  items={tableItems}
                  tablistclassName='overflow-auto'
                />
              </div>
            </div>
          </div>
          <div className='col-sm-12 listview-filters order-first order-lg-0'>
            <div className='w-100 h-100 whitebg bordered1'>
              <div className='filter-section mb-3'>
                <Filters
                  availableFilterValues={inquiryDistinctValues[0]}
                  filter={inquiryFilter}
                  getSearch={getSearch}
                  onClearAll={handleClearAll}
                  onUpdateFilter={updateInquiryFilter}
                  pageType='Inquiries'
                />
              </div>
              <div className='kpis-section mb-3'>
                <KPIs
                  filter={inquiryFilter}
                  onClearAll={handleClearAllKPIs}
                  pageType='INQUIRIES'
                  setKpiName={setKpiName}
                  updateKpiFilter={updateKpiFilter}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
export default InquiriesList
